export type NatalPointPlanetType =
  | 'Sun'
  | 'Moon'
  | 'Neptune'
  | 'Uranus'
  | 'Saturn'
  | 'Jupiter'
  | 'Mars'
  | 'Venus'
  | 'Mercury'
  | 'Pluto'
  | 'NNode'
  | 'Chiron'
  | 'Lilith'
  | 'Asc'
  | 'Mc'

export type NatalPoint =
  | { type: 'planet'; value: NatalPointPlanetType }
  | { type: 'house'; value: number }

export type NatalSection = {
  id: string
  title: string
  description: string
  question: string
  subQuestion: string
  points: NatalPoint[]
  requiresBirthTimeAndLocation?: boolean
}

export type NatalGroup = {
  id: string
  title: string
  sections: NatalSection[]
}

export const NATAL_GROUPS: NatalGroup[] = [
  {
    id: 'personality',
    title: 'Личность',
    sections: [
      {
        id: 'sun',
        title: 'Внутренний стержень',
        description: 'Что в тебе главное, на что ты опираешься и где твоя сила.',
        question: 'Расскажи про моё Солнце. Что во мне главное, где моя сила и как я проявляюсь, когда не пытаюсь никому понравиться?',
        subQuestion: 'Где я предаю себя?',
        points: [{ type: 'planet', value: 'Sun' }],
      },
      {
        id: 'moon',
        title: 'Эмоции',
        description: 'Что тебя успокаивает, задевает и помогает прийти в себя.',
        question: 'Расскажи про мою Луну. Как я проживаю эмоции, что даёт мне чувство безопасности и где меня проще всего задеть?',
        subQuestion: 'Где я себя накручиваю?',
        points: [{ type: 'planet', value: 'Moon' }],
        requiresBirthTimeAndLocation: true,
      },
      {
        id: 'mercury',
        title: 'Мышление',
        description: 'Как ты думаешь, общаешься и принимаешь решения.',
        question: 'Расскажи про мой Меркурий. Как я мыслю, общаюсь, спорю и воспринимаю информацию?',
        subQuestion: 'Почему меня не понимают?',
        points: [{ type: 'planet', value: 'Mercury' }],
      },
      {
        id: 'asc',
        title: 'Первое впечатление',
        description: 'Каким тебя видят люди и какое впечатление ты оставляешь.',
        question: 'Расскажи про мой Асцендент. Как меня видят при знакомстве и какой вайб я транслирую внешне?',
        subQuestion: 'Что я скрываю за образом?',
        points: [{ type: 'planet', value: 'Asc' }],
        requiresBirthTimeAndLocation: true,
      },
      {
        id: 'innerFeminineMasculine',
        title: 'Внутренний баланс',
        description: 'Как в тебе уживаются чувства, желания, характер и действия.',
        question: 'Расскажи про баланс Луны, Венеры, Солнца и Марса во мне. Какую энергию я транслирую и каких людей этим притягиваю?',
        subQuestion: 'Что я в себе подавляю?',
        requiresBirthTimeAndLocation: true,
        points: [
          { type: 'planet', value: 'Moon' },
          { type: 'planet', value: 'Venus' },
          { type: 'planet', value: 'Sun' },
          { type: 'planet', value: 'Mars' },
        ],
      },
      {
        id: 'nervousSystem',
        title: 'Стресс',
        description: 'Как ты ведёшь себя под давлением и реагируешь на перемены.',
        question: 'Расскажи про Меркурий и Уран в моей карте. Как я реагирую на стресс, перегруз и внезапные перемены?',
        subQuestion: 'Что я не могу отпустить?',
        points: [
          { type: 'planet', value: 'Mercury' },
          { type: 'planet', value: 'Uranus' },
        ],
      },
      {
        id: 'loveAndFreedom',
        title: 'Личное пространство',
        description: 'Сколько тебе нужно близости, свободы и времени на себя.',
        question: 'Расскажи про Венеру и Уран в моей карте. Как я переживаю близость, привязанность и потребность в свободе?',
        subQuestion: 'Где я нарушаю свои границы?',
        points: [
          { type: 'planet', value: 'Venus' },
          { type: 'planet', value: 'Uranus' },
        ],
      },
    ],
  },

  {
    id: 'love',
    title: 'Любовь',
    sections: [
      {
        id: 'venus',
        title: 'Как ты любишь',
        description: 'Что тебе важно в отношениях и как ты проявляешь чувства.',
        question: 'Расскажи про мою Венеру. Как я проявляю симпатию, что ценю в отношениях и какая любовь мне подходит?',
        subQuestion: 'Где я себя обесцениваю?',
        points: [{ type: 'planet', value: 'Venus' }],
      },
      {
        id: 'mars',
        title: 'Страсть',
        description: 'Что тебя заводит, как ты проявляешь желание и чего хочешь от близости.',
        question: 'Расскажи про мой Марс. Как я проявляю желание, инициативу, злость и сексуальную энергию?',
        subQuestion: 'Что меня бесит?',
        points: [{ type: 'planet', value: 'Mars' }],
      },
      {
        id: 'idealPartner',
        title: 'Идеальный партнёр',
        description: 'Кто тебя по-настоящему цепляет и с кем тебе будет хорошо.',
        question: 'Расскажи про Венеру и 7 дом в моей карте. Какой партнёр мне подходит и рядом с кем я раскрываюсь лучше всего?',
        subQuestion: 'С кем я теряю себя?',
        points: [
          { type: 'planet', value: 'Venus' },
          { type: 'house', value: 7 },
        ],
        requiresBirthTimeAndLocation: true,
      },
      {
        id: 'passionAndSex',
        title: 'Секс и близость',
        description: 'Что создаёт химию и помогает тебе раскрыться в сексе.',
        question: 'Расскажи про Венеру, Марс и 8 дом в моей карте. Что меня заводит и какая близость ощущается для меня настоящей?',
        subQuestion: 'Что я боюсь показать?',
        points: [
          { type: 'planet', value: 'Venus' },
          { type: 'planet', value: 'Mars' },
          { type: 'house', value: 8 },
        ],
        requiresBirthTimeAndLocation: true,
      },
      {
        id: 'loveBlocks',
        title: 'Блоки в любви',
        description: 'Что мешает строить близкие отношения и заставляет повторять старые сценарии.',
        question: 'Расскажи про Венеру, Сатурн и Хирон в моей карте. Какие страхи, защиты и повторяющиеся сценарии мешают мне в любви?',
        subQuestion: 'Кого я не могу забыть?',
        points: [
          { type: 'planet', value: 'Venus' },
          { type: 'planet', value: 'Saturn' },
          { type: 'planet', value: 'Chiron' },
        ],
      },
      {
        id: 'moonInLove',
        title: 'Как тебя любить',
        description: 'Что помогает тебе довериться, расслабиться и почувствовать себя любимым.',
        question:
          'Расскажи про Луну и 4 дом в моей карте. Что мне нужно в отношениях, чтобы расслабиться, доверять и чувствовать себя любимой?',
        subQuestion: 'Что я боюсь попросить?',
        points: [
          { type: 'planet', value: 'Moon' },
          { type: 'house', value: 4 },
        ],
        requiresBirthTimeAndLocation: true,
      },
      {
        id: 'relationshipRedFlags',
        title: 'Red flags',
        description: 'На какие грабли ты наступаешь в отношениях и кого лучше обходить стороной.',
        question: 'Расскажи про Лилит, Венеру и Марс в моей карте. Какие мои реакции, желания или страхи могут портить отношения?',
        subQuestion: 'Что я путаю с любовью?',
        points: [
          { type: 'planet', value: 'Lilith' },
          { type: 'planet', value: 'Venus' },
          { type: 'planet', value: 'Mars' },
        ],
      },
    ],
  },

  {
    id: 'career',
    title: 'Карьера',
    sections: [
      {
        id: 'vocation',
        title: 'Призвание',
        description: 'В чём ты можешь реализоваться и что даёт тебе ощущение «я на своём месте».',
        question: 'Расскажи про Солнце, 10 дом и Северный узел в моей карте. В чём я могу реализоваться и куда мне правда стоит двигаться?',
        subQuestion: 'Кем я могла стать?',
        points: [
          { type: 'planet', value: 'Sun' },
          { type: 'house', value: 10 },
          { type: 'planet', value: 'NNode' },
        ],
        requiresBirthTimeAndLocation: true,
      },
      {
        id: 'money',
        title: 'Деньги',
        description: 'Как ты обращаешься с деньгами, на чём можешь зарабатывать и что мешает зарабатывать больше.',
        question: 'Расскажи про Венеру, Юпитер и 2 дом в моей карте. Как я зарабатываю, трачу и какие отношения у меня с деньгами?',
        subQuestion: 'На что я сливаю деньги?',
        points: [
          { type: 'planet', value: 'Venus' },
          { type: 'planet', value: 'Jupiter' },
          { type: 'house', value: 2 },
        ],
        requiresBirthTimeAndLocation: true,
      },
      {
        id: 'drive',
        title: 'Амбиции',
        description: 'Как ты добиваешься своего и что помогает тебе не сдаваться.',
        question: 'Расскажи про Марс, Сатурн и 10 дом в моей карте. Как я добиваюсь целей и что помогает мне не сдаться на середине?',
        subQuestion: 'Кому я всё доказываю?',
        points: [
          { type: 'planet', value: 'Mars' },
          { type: 'planet', value: 'Saturn' },
          { type: 'house', value: 10 },
        ],
        requiresBirthTimeAndLocation: true,
      },
      {
        id: 'dailyService',
        title: 'Рабочий ритм',
        description: 'Как тебе комфортнее работать, чтобы не выгорать и успевать больше.',
        question: 'Расскажи про Меркурий и 6 дом в моей карте. Какой формат работы, график и ежедневный ритм мне подходят?',
        subQuestion: 'Что крадёт мою энергию?',
        points: [
          { type: 'planet', value: 'Mercury' },
          { type: 'house', value: 6 },
        ],
        requiresBirthTimeAndLocation: true,
      },
      {
        id: 'uniqueness',
        title: 'Уникальность',
        description: 'Чем ты выделяешься среди других и что делает тебя заметным.',
        question: 'Расскажи про Уран, 10 и 11 дом в моей карте. Через что я выделяюсь и где могу стать заметной для людей?',
        subQuestion: 'Чего я в себе стесняюсь?',
        points: [
          { type: 'planet', value: 'Uranus' },
          { type: 'house', value: 10 },
          { type: 'house', value: 11 },
        ],
        requiresBirthTimeAndLocation: true,
      },
      {
        id: 'jupiter',
        title: 'Удача',
        description: 'Где тебе чаще везёт и какие возможности важно не упускать.',
        question: 'Расскажи про мой Юпитер. Где мне легче расти, получать поддержку и ловить удачные возможности?',
        subQuestion: 'Где мне всё сходит с рук?',
        points: [{ type: 'planet', value: 'Jupiter' }],
      },
      {
        id: 'mc',
        title: 'Репутация',
        description: 'Как тебя видят в работе и за что тебя могут ценить и уважать.',
        question: 'Расскажи про мою Середину неба. Как меня воспринимают в социуме и через что ко мне приходит признание?',
        subQuestion: 'Каким меня запомнят?',
        points: [{ type: 'planet', value: 'Mc' }],
        requiresBirthTimeAndLocation: true,
      },
    ],
  },

  {
    id: 'shadow',
    title: 'Тень',
    sections: [
      {
        id: 'saturn',
        title: 'Уроки',
        description: 'Где тебе пора взрослеть, брать ответственность и перестать наступать на те же грабли.',
        question: 'Расскажи про мой Сатурн. Где мне приходится взрослеть, брать ответственность и переставать убегать от сложного?',
        subQuestion: 'Чего я боюсь признать?',
        points: [{ type: 'planet', value: 'Saturn' }],
      },
      {
        id: 'uranus',
        title: 'Бунт',
        description: 'Какие правила тебя бесят и где тебе особенно нужна свобода.',
        question: 'Расскажи про мой Уран. Где я не могу жить по чужим правилам и в чём моя настоящая свобода?',
        subQuestion: 'Что во мне рвётся наружу?',
        points: [{ type: 'planet', value: 'Uranus' }],
      },
      {
        id: 'neptune',
        title: 'Иллюзии',
        description: 'Где ты склонен идеализировать людей и ситуации и не замечать очевидного.',
        question: 'Расскажи про мой Нептун. Где я могу идеализировать людей, путаться в мечтах и принимать фантазию за реальность?',
        subQuestion: 'Кого я себе придумала?',
        points: [{ type: 'planet', value: 'Neptune' }],
      },
      {
        id: 'pluto',
        title: 'Глубинная сила',
        description: 'Что меняет тебя через кризисы и помогает становиться сильнее.',
        question: 'Расскажи про мой Плутон. Через какие кризисы я меняюсь и где во мне спрятана самая сильная энергия?',
        subQuestion: 'Что меня уже не сломает?',
        points: [{ type: 'planet', value: 'Pluto' }],
      },
      {
        id: 'nnode',
        title: 'Путь души',
        description: 'Куда тебя тянет расти, даже если этот путь не всегда даётся легко.',
        question: 'Расскажи про мой Северный узел. Куда мне двигаться, даже если старые сценарии тянут назад?',
        subQuestion: 'Зачем я здесь?',
        points: [{ type: 'planet', value: 'NNode' }],
      },
      {
        id: 'chiron',
        title: 'Больная точка',
        description: 'Что задевает тебя сильнее всего и как превратить эту уязвимость в силу.',
        question: 'Расскажи про мой Хирон. Где моя уязвимая точка и как через неё я могу стать сильнее?',
        subQuestion: 'Откуда во мне эта боль?',
        points: [{ type: 'planet', value: 'Chiron' }],
      },
      {
        id: 'lilith',
        title: 'Скрытая сторона',
        description: 'Какие желания, страхи и импульсы ты не всегда готов признать даже себе.',
        question: 'Расскажи про мою Лилит. Какие желания, страхи и импульсы я подавляю, но всё равно иногда показываю?',
        subQuestion: 'Чего я тайно хочу?',
        points: [{ type: 'planet', value: 'Lilith' }],
      },
    ],
  },
]

export const NATAL_ADMIN_GROUPS: NatalGroup[] = [
  {
    id: 'personality',
    title: 'Личность',
    sections: [
      {
        id: 'sun',
        title: 'Внутренний стержень',
        description: 'Кто ты без масок',
        question: 'Расскажи про моё Солнце. Что во мне главное, где моя сила и как я проявляюсь, когда не пытаюсь никому понравиться?',
        subQuestion: 'Где я предаю себя?',
        points: [{ type: 'planet', value: 'Sun' }],
      },
      {
        id: 'mercury',
        title: 'Мышление',
        description: 'Как ты думаешь и говоришь',
        question: 'Расскажи про мой Меркурий. Как я мыслю, общаюсь, спорю и воспринимаю информацию?',
        subQuestion: 'Почему меня не понимают?',
        points: [{ type: 'planet', value: 'Mercury' }],
      },
    ],
  },

  {
    id: 'love',
    title: 'Любовь',
    sections: [
      {
        id: 'venus',
        title: 'Как ты любишь',
        description: 'Нежность, симпатия и вкус',
        question: 'Расскажи про мою Венеру. Как я проявляю симпатию, что ценю в отношениях и какая любовь мне подходит?',
        subQuestion: 'Где я себя обесцениваю?',
        points: [{ type: 'planet', value: 'Venus' }],
      },
      {
        id: 'mars',
        title: 'Страсть',
        description: 'Желание, флирт и инициатива',
        question: 'Расскажи про мой Марс. Как я проявляю желание, инициативу, злость и сексуальную энергию?',
        subQuestion: 'Что меня по-настоящему бесит?',
        points: [{ type: 'planet', value: 'Mars' }],
      },
    ],
  },

  {
    id: 'career',
    title: 'Карьера',
    sections: [
      {
        id: 'jupiter',
        title: 'Удача',
        description: 'Где жизнь даёт больше',
        question: 'Расскажи про мой Юпитер. Где мне легче расти, где мне везёт и что мне слишком легко сходит с рук?',
        subQuestion: 'Где я зазнаюсь?',
        points: [{ type: 'planet', value: 'Jupiter' }],
      },
    ],
  },

  {
    id: 'shadow',
    title: 'Тень',
    sections: [
      {
        id: 'saturn',
        title: 'Уроки',
        description: 'Где жизнь просит взрослеть',
        question: 'Расскажи про мой Сатурн. Где мне приходится взрослеть, брать ответственность и переставать убегать от сложного?',
        subQuestion: 'Чего я боюсь признать?',
        points: [{ type: 'planet', value: 'Saturn' }],
      },
      {
        id: 'uranus',
        title: 'Бунт',
        description: 'Где тебе тесно в рамках',
        question: 'Расскажи про мой Уран. Где я не могу жить по чужим правилам и в чём моя настоящая свобода?',
        subQuestion: 'Что во мне рвётся наружу?',
        points: [{ type: 'planet', value: 'Uranus' }],
      },
      {
        id: 'neptune',
        title: 'Иллюзии',
        description: 'Где легко всё романтизировать',
        question: 'Расскажи про мой Нептун. Где я идеализирую людей, путаюсь в мечтах и принимаю фантазию за реальность?',
        subQuestion: 'От чего я прячусь в мечтах?',
        points: [{ type: 'planet', value: 'Neptune' }],
      },
      {
        id: 'pluto',
        title: 'Глубинная сила',
        description: 'Через что ты меняешься',
        question: 'Расскажи про мой Плутон. Через какие кризисы я меняюсь и где во мне спрятана самая сильная, неубиваемая энергия?',
        subQuestion: 'Что меня уже не сломает?',
        points: [{ type: 'planet', value: 'Pluto' }],
      },
      {
        id: 'nnode',
        title: 'Путь души',
        description: 'Куда тебя тянет жизнь',
        question: 'Расскажи про мой Северный узел. Куда мне двигаться, даже если старые сценарии тянут назад?',
        subQuestion: 'Зачем я здесь?',
        points: [{ type: 'planet', value: 'NNode' }],
      },
      {
        id: 'chiron',
        title: 'Больная точка',
        description: 'Где рана становится силой',
        question: 'Расскажи про мой Хирон. Где моя уязвимая точка и как через неё я могу стать сильнее?',
        subQuestion: 'Откуда во мне эта боль?',
        points: [{ type: 'planet', value: 'Chiron' }],
      },
      {
        id: 'lilith',
        title: 'Скрытая сторона',
        description: 'Что ты обычно прячешь',
        question: 'Расскажи про мою Лилит. Какие желания, страхи и импульсы я подавляю, но всё равно иногда показываю?',
        subQuestion: 'Чего я тайно хочу?',
        points: [{ type: 'planet', value: 'Lilith' }],
      },
    ],
  },
]
